import { Component, OnInit } from '@angular/core';
import { default_FilterDrawerLayoutComponent } from '../../default/filter-drawer-layout/filter-drawer-layout.component';
import moment from 'moment';

@Component({
  selector: 'app-client-filter-drawer-layout',
  templateUrl: '../../default/filter-drawer-layout/filter-drawer-layout.component.html',
  styleUrls: ['../../default/filter-drawer-layout/filter-drawer-layout.component.scss'],
})
export class paepae_FilterDrawerLayoutComponent extends default_FilterDrawerLayoutComponent implements OnInit {
  hasStreamBranding: boolean = true;
  hasLogo: boolean = false;
}
